import { Component, OnInit, Input, EventEmitter, ViewChild } from '@angular/core';

declare var $:any; 

@Component({
  selector: 'produto-galeria',
  templateUrl: './produto-galeria.component.html',
  styleUrls: ['./produto-galeria.component.scss']
})
export class ProdutoGaleriaComponent implements OnInit {

  @Input("photos") photos:any       = [];
  @ViewChild("gallery") gallery:any = null;
  public width = null;
  public slideIndex = 1;
  public timeSlider = 5000;
  public timeoutHandle = null;

  constructor(){}
    
  /**
   * 
   * Create
   * 
   */
  create(){

    //$(this.gallery.nativeElement).fotorama();
    setTimeout(() => {
      this.showSlides(1); 
      this.startSlider();
    },100);

  }
  /**
   * 
   * On 
   * 
   */
   _onResize(){

    this.width = window.innerWidth; 

  }
  // Next/previous controls
  plusSlides(n,reset=true) {
    this.showSlides(this.slideIndex += n);
    if(reset && this.timeoutHandle != null){
      window.clearTimeout(this.timeoutHandle);
      this.startSlider();
    }
  }
  // Thumbnail image controls
  currentSlide(n,reset=true) {
    this.showSlides(this.slideIndex = n);
    if(reset && this.timeoutHandle != null){
      window.clearTimeout(this.timeoutHandle);
      this.startSlider();
    }
  }
  showSlides(n) {
  
    var i;
    var slides:any = document.getElementsByClassName("slide-show-template");
    var dots:any   = document.getElementsByClassName("dot");

    if (n > slides.length) {this.slideIndex = 1}
    if (n < 1) {this.slideIndex = slides.length}
    for (i = 0; i < slides.length; i++) {
        slides[i].style.display = "none";
    }
    for (i = 0; i < dots.length; i++) {
        dots[i].className = dots[i].className.replace(" active", "");
    }
    slides[this.slideIndex-1].style.display = "block";
    dots[this.slideIndex-1].className += " active";

  }
  /**
   * 
   * start
   * 
   */
  startSlider(){

    let self = this;

    self.timeoutHandle = setTimeout(() => {

      self.plusSlides(1,false); 
      self.startSlider();

    },self.timeSlider); 

  }
  /***
   * 
   * Inicializa as Funções
   * 
   * 
   */
  ngOnInit(){
    this.create();
    this.width = window.innerWidth;
  }
  /**
   * 
   * init
   * 
   */
  ngAfterViewInit(): void {
    //this.create();
  }

}
